import useReactHookForm from "hooks/useReactHookForm";
import { useAppDispatch } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useLazyQuery, useMutation } from "@apollo/client";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Nl3PackageScheduleInitialValues,
  Nl3PackageScheduleMandatoryFields,
  Nl3PackageScheduleProperties,
  Nl3PackageScheduleValidationSchema
} from "./helper";
import liveClassClientService from "utils/graphql/liveclassClient";
import { CREATE_NLEARN3_PACKAGE_SCHEDULE } from "utils/graphql/services/live-classes/mutations";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";

export const CreateNl3PackageSchedule = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    Nl3PackageScheduleInitialValues,
    Nl3PackageScheduleValidationSchema,
    Nl3PackageScheduleMandatoryFields
  );

  const [CreateNlearn3PackageSchedule, { loading, error, data }] = useMutation(
    CREATE_NLEARN3_PACKAGE_SCHEDULE,
    {
      client: liveClassClientService,
    }
  );

  const handleCreateNl3PackageSchedule = async () => {
    try {
      const response: any = await CreateNlearn3PackageSchedule({
        variables: {
          input: {
            projectId: watch()?.projectId,
            vendorId: watch()?.vendorId,
            vendorAccountId: Number(watch()?.vendorAccountId),
            scheduledStartTime: watch()?.start_date_time,
            scheduledEndTime: watch()?.end_date_time,
            nlearn3LiveclassPackageIds: watch()?.nlearn3LiveclassPackageIds,
            meetingTitle: watch()?.meetingTitle,
            meetingSubTitle: watch()?.meetingSubTitle,
            thumbnailUrl: watch()?.thumbnailUrl,
            notesUrl: watch()?.notesUrl,
            employeeDepartmentId: watch()?.departmentId,
            employeeDesignationId: watch()?.designationId,
            teacherId: watch()?.teacherId,
            vendorUserId: watch()?.vendorUserId,
          },
        },
      });

      if (!isEmpty(response?.data?.createNlearn3PackageSchedule?.id)) {
        dispatch(
          snackbarRequest({
            message: `Created Nl3 Package Schedule successfully`,
          })
        );
        history.replace(`/live-classes/nlearn3-package-schedules`);
      } else {
        dispatch(
          snackbarRequest({
            message: `Failed to create Nl3 Package Schedule`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message: `${err?.message}` || `Failed to create Nl3 Package Schedule`,
          type: "error",
        })
      );
    }
  };

  return (
    <div>
      <TypographyHeading>Create Nlearn3 Package Schedule</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={Nl3PackageScheduleProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateNl3PackageSchedule}
              loading={loading}
              disabled={!isFieldsValidate(errors, Nl3PackageScheduleMandatoryFields, getValues)}
            >
              Create
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
